/* eslint-disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".wrapper_0520b5ad{height:340px}.button_0520b5ad{margin:17px 10px 0 0}"}]);
export const wrapper = "wrapper_0520b5ad";
export const button = "button_0520b5ad";